import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import {
  API_ERROR,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  token: "",
  data: {},
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        token: action.payload.data.token,
        data: action.payload.data.user,
      }
      break
    case LOGIN_FAIL:
      state = {
        ...state,
        loading: false,
        error: action.payload.message,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state, token: action.payload.data, data: {} }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}
const persistConfig = {
  key: "login",
  storage,
}

export default persistReducer(persistConfig, login)
